import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=67fa8971&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=js&"
export * from "./Score.vue?vue&type=script&lang=js&"
import style0 from "./Score.vue?vue&type=style&index=0&id=67fa8971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa8971",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fa8971')) {
      api.createRecord('67fa8971', component.options)
    } else {
      api.reload('67fa8971', component.options)
    }
    module.hot.accept("./Score.vue?vue&type=template&id=67fa8971&scoped=true&", function () {
      api.rerender('67fa8971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/Score.vue"
export default component.exports